/**
 * ReconciliationTab.js
 * Reconciliation tab content component
 */

import React from 'react';
import { Box, Paper, Stack, Typography, useTheme, alpha } from '@mui/material';
import { AccountBalance as BankIcon } from '@mui/icons-material';

import TransactionMatchingPanel from './TransactionMatchingPanel';

const ReconciliationTab = ({
  selectedStatement,
  transactions,
  journalEntries,
  selectedTransactions,
  selectedJournalEntries,
  isLoadingTransactions,
  isLoadingJournalEntries,
  transactionTypeFilter,
  reconciliationFilter,
  selectedTransactionTotal,
  selectedJournalEntryTotal,
  selectionDifference,
  canReconcile,
  onTransactionToggle,
  onJournalEntryToggle,
  onReconcile,
  onFindMatches,
  onTransactionTypeFilterChange,
  onReconciliationFilterChange,
  executeUnreconciliation,
  onCreateEntry,
  onBulkEditStart,
  onBulkCreateEntries,
  onEdit,
  onDelete,
}) => {
  const theme = useTheme();

  if (!selectedStatement) {
    return (
      <Paper
        elevation={2}
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 3,
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          border: '2px dashed rgba(0,0,0,0.1)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        }}
      >
        <Stack spacing={2} alignItems="center" textAlign="center" sx={{ p: 3 }}>
          <Box
            sx={{ p: 2, borderRadius: '50%', backgroundColor: alpha(theme.palette.grey[400], 0.1) }}
          >
            <BankIcon sx={{ fontSize: 40, color: 'grey.400' }} />
          </Box>
          <Box>
            <Typography variant="h6" color="grey.600" gutterBottom fontWeight="600">
              Selecione um Extrato
            </Typography>
            <Typography variant="body2" color="grey.500" maxWidth="400px">
              Para começar a conciliação, primeiro selecione um extrato bancário na aba anterior.
            </Typography>
          </Box>
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={2}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        overflow: 'hidden',
        minHeight: 0,
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        border: '1px solid rgba(0,0,0,0.06)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}
    >
      <TransactionMatchingPanel
        selectedStatement={selectedStatement}
        transactions={transactions}
        journalEntries={journalEntries}
        selectedTransactions={selectedTransactions}
        selectedJournalEntries={selectedJournalEntries}
        isLoadingTransactions={isLoadingTransactions}
        isLoadingJournalEntries={isLoadingJournalEntries}
        onTransactionToggle={onTransactionToggle}
        onJournalEntryToggle={onJournalEntryToggle}
        onReconcile={onReconcile}
        onFindMatches={onFindMatches}
        canReconcile={canReconcile}
        selectionDifference={selectionDifference}
        selectedTransactionTotal={selectedTransactionTotal}
        selectedJournalEntryTotal={selectedJournalEntryTotal}
        transactionTypeFilter={transactionTypeFilter}
        onTransactionTypeFilterChange={onTransactionTypeFilterChange}
        reconciliationFilter={reconciliationFilter}
        onReconciliationFilterChange={onReconciliationFilterChange}
        executeUnreconciliation={executeUnreconciliation}
        onCreateEntry={onCreateEntry}
        onBulkEditStart={onBulkEditStart}
        onBulkCreateEntries={onBulkCreateEntries}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Paper>
  );
};

export default ReconciliationTab;
